import { useDispatch } from 'react-redux';

import { RadioGroup } from '@/components/RadioGroup';
import {
    EBorrowerMaritalStatus,
    selectMaritalStatus,
    setMaritalStatus,
} from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';
import { useFieldCopy } from '@/copy';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'maritalStatus';

export function MarriageStatus({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    // Not using the redux hooks (eg, useAppSelector) here because we need to use the index - extra args
    const fields = useFieldCopy();
    const maritalStatus = useAppSelector(selectMaritalStatus);
    const dispatch = useDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        dispatch(setMaritalStatus(value as EBorrowerMaritalStatus));
    }
    // ***** Render *****
    const options = [
        {
            // eslint-disable-next-line spellcheck/spell-checker
            label: fields.marriageStatusOptions.married,
            value: EBorrowerMaritalStatus.MARRIED,
            id: `${baseId}-button-maritalStatus-married`,
        },
        {
            label: fields.marriageStatusOptions.single,
            value: EBorrowerMaritalStatus.SINGLE,
            id: `${baseId}-button-livingStatus-renter`,
        },
    ];
    return (
        <div data-testid='maritalStatus'>
            <RadioGroup
                title={fields.marriageStatus}
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={maritalStatus}
            />
        </div>
    );
}
